module.exports = __webpack_public_path__ + "static/media/zorrat.4acbd5e2.png";